import { createContext, useContext } from "react";
import { useCloseAutonomousCheckout } from "./useCloseAutonomousCheckout";
import { useCloseSkuInBoxCheckout } from "./useCloseSkuInBoxCheckout";
import { useCancelSkuInBoxCheckout } from "./useCancelSkuInBoxCheckout";

export type CheckoutContextValue = {
  closeSession: () => void;
  cancelSession: () => void;
  isCloseLoading?: boolean;
  isCancelLoading?: boolean;
};

export const CheckoutContext = createContext<CheckoutContextValue>({
  closeSession: () => {
    throw Error("Component is not wrapped with PaymentContext");
  },
  cancelSession: () => {
    throw Error("Component is not wrapped with PaymentContext");
  },
  isCloseLoading: false,
  isCancelLoading: false,
});

export const useCheckout = () => useContext(CheckoutContext);

export const SkuInBoxCheckoutProvider = ({
  children,
}: React.PropsWithChildren) => {
  const [closeSession, { isLoading: isCloseLoading }] =
    useCloseSkuInBoxCheckout();
  const [cancelSession, { isLoading: isCancelLoading }] =
    useCancelSkuInBoxCheckout();

  return (
    <CheckoutContext.Provider
      value={{ closeSession, cancelSession, isCancelLoading, isCloseLoading }}
    >
      {children}
    </CheckoutContext.Provider>
  );
};

export const AutonomousCheckoutProvider = ({
  children,
}: React.PropsWithChildren) => {
  const closeSession = useCloseAutonomousCheckout();

  return (
    <CheckoutContext.Provider
      value={{ closeSession, cancelSession: closeSession }}
    >
      {children}
    </CheckoutContext.Provider>
  );
};
